module.exports = __webpack_public_path__ + "static/media/logo_bg.b6ec90af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_bg.png
// module id = 5956
// module chunks = 0